import React from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import Loading from "../../common/Loading/Loading";
import './ConfirmDialog.css';

class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.toggleState
    };
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.toggleState !== this.props.toggleState) {
      this.toggle();
    }
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    return (
        <span>
        <Modal isOpen={this.state.modal} className="modal-container" size="lg">
          {!this.props.isLoading
              ? <ModalHeader toggle={() => {
                this.toggle();
                this.props.cancelAction();
              }}>{this.props.caption}</ModalHeader>
              : <ModalHeader>{this.props.caption}</ModalHeader>
          }
          {!this.props.isLoading &&
          <ModalBody>
            {this.props.message}
          </ModalBody>
          }
          {this.props.isLoading &&
            <ModalBody className="loading-body">
             <Loading />
            </ModalBody>
          }
          <ModalFooter>
            <Button 
              color="btn btn-link" 
              onClick={() => { this.toggle(); this.props.cancelAction();}}
              disabled={this.props.isLoading}
            >
              Cancel
            </Button>
            {this.props.confirmAction && (
              <Button
                  type="button"
                  className={"btn submit-user-button " + (this.props.confirmClassName ? this.props.confirmClassName : "btn-success")}
                  onClick={() => this.props.confirmAction()}
                  disabled={this.props.isLoading}
              >
                {this.props.confirmActionName}
              </Button>
            )}
          </ModalFooter>
        </Modal>
      </span>
    );
  }
}

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./src/common/ConfirmDialog/ConfirmDialog.js